import { reportErrorToSentry } from '@commercetools-frontend/sentry';

export const mapLocaleToIntlLocale = (locale) => {
  if (locale.startsWith('de')) return 'de';
  if (locale.startsWith('es')) return 'es';
  if (locale.startsWith('fr')) return 'fr-FR';
  if (locale === 'zh-CN') return 'zh-CN';
  if (locale.startsWith('ja')) return 'ja';
  return 'en';
};

const loadMessages = (locale) => {
  const intlLocale = mapLocaleToIntlLocale(locale);
  switch (intlLocale) {
    case 'de':
      return import(/* webpackChunkName: "local-i18n-de" */ './data/de.json');
    case 'es':
      return import(/* webpackChunkName: "local-i18n-es" */ './data/es.json');
    case 'fr-FR':
      return import(
        /* webpackChunkName: "local-i18n-fr-FR" */ './data/fr-FR.json'
      );
    case 'zh-CN':
      return import(
        /* webpackChunkName: "local-i18n-zh-CN" */ './data/zh-CN.json'
      );
    case 'ja':
      return import(/* webpackChunkName: "local-i18n-ja" */ './data/ja.json');
    default:
      return import(/* webpackChunkName: "local-i18n-en" */ './data/en.json');
  }
};

// eslint-disable-next-line import/prefer-default-export
export const loadI18n = async (locale) => {
  try {
    const messages = await loadMessages(locale);
    return messages.default || messages;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      `Something went wrong while loading the core messages for ${locale}`,
      error
    );
    reportErrorToSentry(
      new Error(
        `Something went wrong while loading the core messages for ${locale}`
      ),
      { extra: error }
    );
    return {};
  }
};
